import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=19b49a9d"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCarousel: require('/opt/build/repo/components/product/Carousel.vue').default,NewsletterSubscribe: require('/opt/build/repo/components/NewsletterSubscribe.vue').default,SocialAccounts: require('/opt/build/repo/components/SocialAccounts.vue').default})
